import userEventService from './user-event-service';

const EVENT_CATEGORY = 'broker_verification_metrics';
const EVENT_ACTION = 'broker_verification_market_resolved';

// Blank values are left out, not sent as empty strings. user_id/timestamp come from
// user-event-service. Never throws: tracking must not disrupt the user's workflow.
const trackVerificationMarket = ({ dealId, edpPropertyId, market }) => {
  try {
    userEventService.trackEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: EVENT_ACTION,
      eventData: {
        deal_id: dealId,
        edp_property_id: edpPropertyId === '' ? undefined : (edpPropertyId ?? undefined),
        market: market || undefined,
      },
    });
  } catch (error) {
    console.error('Failed to track broker verification market');
  }
};

export { EVENT_CATEGORY, EVENT_ACTION, trackVerificationMarket };

export default { trackVerificationMarket };
